import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 900px;

  .title {
    font-size: clamp(40px, 5vw, 60px);
    text-align: center;
  }

  p {
    text-align: center;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
    display: block;
    text-align: center;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading">Drop Me a Line</h2>

      <p>
        Look, I'm not actively hunting for new gigs right now - got two boys who think I'm their
        personal Grab driver and a Lego collection that's slowly taking over the house. But my inbox
        is always open.
      </p>

      <p>
        Got a cool project? Want to bounce ideas around? Or just want to share your idea with
        someone? Drop me a line. I might not know everything (definitely don't), but I'd love to
        hear what you're working on. Fair warning though - I hate email and sometimes forget to
        check it for weeks. But when I do reply, it'll be worth the wait.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Say Hello
      </a>

      <p>&nbsp;</p>

      <p>
        <i>
          P.S. - If you're a recruiter trying to sell me on 'amazing opportunities' that require 47
          different programming languages and pay in exposure, maybe just... don't. But if you have
          something genuinely interesting, let's talk.
        </i>
      </p>
    </StyledContactSection>
  );
};

export default Contact;
